// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Help = ({ fill, svgComponents: { G, Path, Rect } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z" />
            <Path d="M20,29a9,9,0,1,1,9-9A9,9,0,0,1,20,29Zm0-17a8,8,0,1,0,8,8A8,8,0,0,0,20,12Z" />
            <Rect height="7.06" transform="translate(-12.46 28.15) rotate(-45)" width="1" x="27.25" y="25.58" />
            <Rect height="7.06" transform="translate(-5.46 11.26) rotate(-45)" width="1" x="10.36" y="8.69" />
            <Rect height="7.02" transform="translate(-11.08 28.74) rotate(-45)" width="1" x="28.65" y="24.24" />
            <Rect height="7.06" transform="translate(-4.08 11.83) rotate(-45)" width="1" x="11.75" y="7.31" />
            <Rect height="1" transform="translate(-0.11 24.18) rotate(-45)" width="7.06" x="25.61" y="11.72" />
            <Rect height="1" transform="translate(-17.01 17.18) rotate(-45)" width="7.02" x="8.72" y="28.63" />
            <Rect height="1" transform="translate(0.47 22.8) rotate(-45)" width="7.06" x="24.22" y="10.34" />
            <Rect height="1" transform="translate(-16.44 15.8) rotate(-45)" width="7.03" x="7.34" y="27.24" />
        </G>
    );
};

export default Help;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/help/index.js